/*
 * @Date: 2024-02-22 14:33:11
 * @LastEditors: lidya lidya 1612405095@qq.com
 * @LastEditTime: 2025-06-04 16:59:23
 * @FilePath: /bookhockey.com/src/main.ts
 */
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import App from './App.vue';
import router from './router';
import { usePermissStore } from './store/permiss';
import 'element-plus/dist/index.css';
import './assets/css/icon.css';
import VueAwesomeSwiper from 'vue-awesome-swiper';



const app = createApp(App);
import ScriptX from 'vue-scriptx'
app.use(ScriptX)

import Ads from 'vue-google-adsense'
app.use(Ads.Adsense)
app.use(Ads.InArticleAdsense)
app.use(Ads.InFeedAdsense)
app.use(createPinia());
app.use(router);
app.use(VueAwesomeSwiper)
// 注册elementplus图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component);
}
// 自定义权限指令
const permiss = usePermissStore();
app.directive('permiss', {
    mounted(el, binding) {
        if (!permiss.key.includes(String(binding.value))) {
            el['hidden'] = true;
        }
    },
});
export { router }; // 导出路由实例
app.mount('#app');
